import Vue from "vue";
import Vuex from "vuex";
import {
  algolia,
  equipment,
  auth,
  statics,
  navheight
} from "./modules";

Vue.use(Vuex);
export default new Vuex.Store({
  strict: false,
  modules: {
    algolia,
    equipment,
    auth,
    statics,
    navheight
  },
});
